// packages/data/src/select.ts
import defaultRegistry from "./default-registry";
function select(storeNameOrDescriptor) {
  return defaultRegistry.select(storeNameOrDescriptor);
}
export {
  select
};
//# sourceMappingURL=select.js.map
